import { Form } from 'formik';
import styled, { css } from 'styled-components';
import { Modal, Form as FormBoot } from 'react-bootstrap';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 370px;
  margin-top: 165px;

  h1 {
    color: ${({ theme }) => theme.colors.blue};
    font-size: 1.4375rem;
    font-weight: bold;
    text-align: left;
    line-height: 18px;
    margin-bottom: 12px;
  }

  h2 {
    color: #5E5E5E;
    font-size: 0.9375rem;
    text-align: left;
    line-height: 26px;
    margin-bottom: 22px;
  }

  a {
    text-decoration: none;
  }

  @media (max-width: 768px) {
    margin-top: 0;
    min-height: calc(100vh - 356px);
  }
`;

export const SelectTypeValidation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
`;

export const FormRadioContent = styled.div`
  box-shadow: 0px 0px 10px -4px rgb(0 0 0 / 75%);
  display: flex;
`;

export const FormRadio = styled(FormBoot.Check)`
  padding: 0;

  .form-check-input {
    position: absolute;
    z-index: 10;
    opacity: 0;
}

  .form-check-label {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 40px;
    line-height: normal;
    border-bottom: 0 solid #00FF00;
    text-align: center;
    background: #000FFF;
    color: #FFF;
    font-weight: bold;
    margin: 0;
    user-select: none;

    &::before, &::after {
      content: none;
    }
  }

  ${({ isSelect }) => isSelect && css`
    .form-check-label {
      border-width: 2px;
    }
  `}
`;

export const Label = styled.span`
  color: #5E5E5E;
  svg {
    margin-left: -5px;
    margin-right: 4px;
  }
  margin-bottom: 22px;
`;

export const FormContainer = styled.form`
  width: 100%;
`;

export const FormContainerModal = styled(Form)`
  width: 100%;
`;

export const InputsContainer = styled.div`
  width: 100%;
  margin-bottom: 30px;
`;


export const ButtonsContainer = styled.div`
  width: 100%;

  :nth-child(2) {
    button {
      margin-top: 20px;
    }
  }
`;

export const Field = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ContactCard = styled.div`
  display: grid;
  grid-template-columns: 60px auto;
  column-gap: 26px;
`;

export const InforCardContact = styled.section`
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.darkYellow};
  border-radius: 3px;
  padding: 17px 20px 17px 20px;
  margin-top: 20px;

  h1 {
    color: black;
    margin: 0;
    margin-bottom: 20px;
  }
`;

export const IconContact = styled.div`
	height: 60px;
	width: 60px;
	border: 4px solid ${({ theme }) => theme.colors.darkYellow};
	border-radius: 50%;
	color: ${({ theme }) => theme.colors.darkYellow};
	padding: 4px;
	display: flex;
	place-items: center;
	place-content: center;
  place-self: center;
`;

export const Contacts = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 0.8125rem;

  p:first-child {
    margin-bottom: 8px;
  }

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.darkBlue};
    line-height: 1.5625rem;
  }

  a {
    text-decoration: none;
    color: #808495;
  }
`;

export const MessagerAwait = styled.span`
  margin-top: 6px;
  font-size: 0.8125rem;
  color: #8F8F8F;
`;

export const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;

  button {
    width: 100%;
    max-width: 160px;
  }
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 648px;
    width: 100%;
    border-radius: 10px;
  }
  .modal-dialog-centered {
    max-width: 648px !important;
    place-content: center;
  }
`;

export const ContentField = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 1fr;
  gap: 15px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2px;
    margin-bottom: 10px;
  }

  & div:first-of-type {
    margin-bottom: 0;
  }
`;

export const ContentToken = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 450px;
  width: 100%;
  margin: 0 auto;
  padding: 15px;
  border-top: 1px dashed #D8D8D8;

  #content-buttons {
    flex-direction: column;
    gap: 15px;

    > button {
      width: 100%;
    }
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: space-around;

  button {
    width: 40%;
  }
`;

export const TextLabel = styled.span`
  color: #0B24FB;
`;

export const TextTimer = styled.p`
  text-align: center;

  a {
    color: #0000ff;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 39px 28px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 18px;
    width: 100%;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    place-content: space-between;

    div {
      display: flex;
      flex-direction: column;

      h2 {
        margin: 0;
        color: #0B24FB;
        font-size: 18px;
        font-weight: 400;
      }
      span {
        color: #7A7A7A;
      }
    }
  }

  svg {
    color: ${({ theme }) => theme.colors.darkBlue};
    cursor: pointer;
    margin-left: 10px;
  }

  margin-bottom: 16px;
`;

export const TokenLink = styled.a`
	cursor: pointer;
	color: #074F8C !important;
	font-size: 0.875rem;
	line-height: 17px;

  ${(props) => props.invalidToken && css`
    color: #dc3545 !important;
  `}
`;
